import React, { useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import LinkButton from '../atoms/button/LinkButton';
import LineTitleGray from '../atoms/titles/LineTitleGray';
import SortList from '../molecules/SortList';
import DataUpdateTimeDisplay from '../molecules/DataUpdateTimeDisplay';
import SearchResultFacility from '../organisms/SearchResultFacility';
import SearchConditionSPHotel from '../organisms/SearchConditionSPHotel';
import PlanDetail from '../pages/PlanDetail';
import ModalAccommodationConditions from '../modal/ModalAccommodationConditions';
import {
  fetchHotels,
  setSortOrder,
} from '../../modules/hotel';
import {
  fetchPendingPlan,
  handleAddPlan,
  removePendingPlan,
} from '../../modules/planDetail';
import { makeHotelsInput, makePlanInput } from '../../utils/input';
import { scrollToTop } from '../../utils/scroll';
import { SHOWING_HOTEL_LIMIT } from '../../constants';

const selector = (state) => ({
  flight: state.flight,
  hotel: state.hotel,
  planDetail: state.planDetail,
});

const SearchHotelSP = ({ maxStayNights, planStartDate, planIndex, toggleEditingAccommodation, editingAccommodation }) => {
  const dispatch = useDispatch();
  const { flight, hotel, planDetail } = useSelector(selector);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => (
    () => dispatch(removePendingPlan())
  ), []);

  const {
    flightsInput,
    outboundFlights,
    inboundFlights,
    searchedFlightsInput,
    selectedOutboundDate,
  } = flight;

  const {
    hotelsInput,
    paginatorInfo,
    hotels,
    searchedHotelsInput,
  } = hotel;
  const { plans: selectedPlans, pendingPlan } = planDetail;

  const [hotelIdsWithExpandPlanList, setHotelIdsWithExpandPlanList] = useState([]);

  const toggleModalOpen = useCallback(
    () => {
      setModalOpen(!modalOpen);
    },
    [modalOpen],
  );

  const planStartDateDiplay = moment(planStartDate).format('YYYY年M月D日(ddd)');
  const title = `宿泊内容変更 ${planIndex}日目 ${planStartDateDiplay}`;

  const validOutbound = !!(outboundFlights && outboundFlights.length);
  const validInbound = !!(inboundFlights && inboundFlights.length);
  const showSortList = !!(validOutbound && validInbound && hotels && hotels.length);
  const dataUpdateTime = !!(hotels && hotels.length) && hotels[0].dataUpdateTime;

  const handlePlanSelect = (plan) => {
    const { stayNights } = hotelsInput;
    dispatch(handleAddPlan(plan, planStartDate, stayNights, searchedHotelsInput, searchedFlightsInput));

    toggleEditingAccommodation();
    setHotelIdsWithExpandPlanList([]);
  };

  const tripStartDate = moment(selectedOutboundDate);
  const formatedTripStartDate = tripStartDate.clone().format('YYYY-MM-DD');

  const _hotelsInput = planIndex === 1 ? {
    ...hotelsInput,
    hotelCode: selectedPlans.find(p => p.startDate === planStartDate).plan.hotel.id,
  } : {
    ...hotelsInput,
    provider: selectedPlans.find(p => p.startDate === formatedTripStartDate).plan.provider,
    excludeLandingFlag: 1, // プラン追加時は着地ありプランは除外する
    searchCondition: [], //  プラン追加時は着地用こだわり条件はクリア
    hotelCode: '', // プラン追加時はhotelCodeをクリア
    groupId: '',// プラン追加時はgroupIdをクリア
    itemCD: '', // プラン追加時はITEM_CDをクリア
    planPerHotel: "20", // プラン追加時はplanPerHotelを20に設定
  };

  const handleHotelSearch = (callback) => {
    dispatch(
      fetchHotels(
        makeHotelsInput(_hotelsInput, flightsInput, planStartDate),
        SHOWING_HOTEL_LIMIT,
        1,
        callback,
      )
    );

    setHotelIdsWithExpandPlanList([]);
  };

  return (
    <div className="pageSearch">
      <LineTitleGray
        size="lg"
        // linkTitle="変更せずに戻る"
        // handleLinkClick={() => toggleEditingAccommodation(false)}
      >
        {title}
      </LineTitleGray>
      {pendingPlan ? (
        <PlanDetail
          handlePlanSelect={handlePlanSelect}
          selectedPlan={pendingPlan}
          handlePlanListLink={() => {
            dispatch(removePendingPlan());
            scrollToTop(false);
          }}
          handlePlanListLinkBottom={() => {
            dispatch(removePendingPlan());
            scrollToTop(false);
          }}
          editingAccommodation={editingAccommodation}
        />
      ) : (
        <React.Fragment>
          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <div style={{ padding: 16 }}>
              <SearchConditionSPHotel handleSearch={() => handleHotelSearch(() => {})} />
            </div>
            <LinkButton onClick={toggleModalOpen}>宿泊条件を変更する</LinkButton>
          </div>
          {showSortList && (
            <div className="sortListWrapper">
              <SortList
                value={hotelsInput.sortOrder}
                handleChange={(sortOrder) => {
                  dispatch(setSortOrder(sortOrder));

                  if (!paginatorInfo) {
                    return;
                  }

                  const { currentPage } = paginatorInfo;
                  const newhotelsInput = {
                    ..._hotelsInput,
                    sortOrder,
                  };

                  dispatch(
                    fetchHotels(
                      makeHotelsInput(newhotelsInput, flightsInput, planStartDate),
                      SHOWING_HOTEL_LIMIT,
                      currentPage
                    )
                  );
                }}
              />
              {!!dataUpdateTime && (
                <DataUpdateTimeDisplay dataUpdateTime={dataUpdateTime} editingAccommodation={editingAccommodation} />
              )}
            </div>
          )}
          <div className="searchResultFacilityWrapper">
            <SearchResultFacility
              handlePlanSelect={handlePlanSelect}
              handleClickPlanDetailLink={(plan, roomTypeId) => {
                const planInput = makePlanInput(plan.id, roomTypeId, searchedHotelsInput, searchedFlightsInput, planStartDate);
                dispatch(fetchPendingPlan(planInput));
                scrollToTop(false);
                setHotelIdsWithExpandPlanList([]);
              }}
              hidePlanListLink={false}
              planStartDate={planStartDate}
              handleClickPlanListLink={(hotel) => {
                setHotelIdsWithExpandPlanList([...hotelIdsWithExpandPlanList, hotel.id]);
              }}
              hotelIdsWithExpandPlanList={hotelIdsWithExpandPlanList}
              fetchHotelsInput={makeHotelsInput(_hotelsInput, flightsInput, planStartDate)}
              editingAccommodation={editingAccommodation}
            />
          </div>
        </React.Fragment>
      )}
      <div style={{ textAlign: 'center', marginTop: 40 }}>
        <LinkButton buttonType="navigateMin" onClick={() => toggleEditingAccommodation(false)}>戻る</LinkButton>
      </div>
      <ModalAccommodationConditions
        open={modalOpen}
        onClose={toggleModalOpen}
        hideRoom
        hideDestination={planIndex === 1}
        handleSearch={() => handleHotelSearch(toggleModalOpen)}
        maxStayNights={maxStayNights}
        hideSearchCondition={planIndex !== 1}
        excludeLanding={planIndex !== 1}
        isPlanList
      />
    </div>
  );

};

SearchHotelSP.propTypes = {
  maxStayNights: PropTypes.number,
  planStartDate: PropTypes.string,
  planIndex: PropTypes.number,
  toggleEditingAccommodation: PropTypes.func.isRequired,
  editingAccommodation: PropTypes.bool.isRequired,
};

export default SearchHotelSP;
